<template>
  <div class="border border-blue-light rounded shadow bg-white">
    <header v-if="showHeader" class="w-full p-4 text-xl font-thin uppercase text-blue-light">
      {{ $t( form.id != null  ? 'edit_status' : 'add_status') }}
    </header>
    <div class="w-full px-4 pb-4 pt-4">
      <form @submit.prevent class="w-full">
        <div class="mb-1">

          <!-- <div class="w-full pb-3">
            <div class="w-full">
              <label form="code" class="">{{ $t('code')}}</label>
              <v-input
                v-model="form.code"
                title="code"
                type="text"
                name="code"
                placeholder="code"
              />
            </div>
          </div> -->

          <div class="w-full pb-3">
            <div class="w-full">
              <b-field :label="$t('name')">
                <v-input
                  v-model="form.name"
                  title="name"
                  type="text"
                  required="true"
                  name="name"
                  placeholder="name"
                />
              </b-field>
            </div>
          </div>

          <div v-if="weightingCriteria !== 'default'" class="w-full pb-3">
            <div class="w-full">
              <b-field :label="$t('weight')">
                <b-numberinput v-model="form.weight"
                  placeholder="0"
                  :min="-100"
                  :max="100"
                  controls-position="compact"
                  expanded
                  :disabled="weightingCriteria !== 'custom'"
                  icon-pack="fas"></b-numberinput>
              </b-field>
            </div>
          </div>

          <div class="w-full pb-3">
            <b-field :label="$t('select_a_color')">
              <b-colorpicker v-model="form.color"
                :alpha="false"
                :inline="colorpickerInline"
                :color-formatter="formatter"
                size="is-medium"
                expanded
              />
            </b-field>
          </div>

          <div class="w-full pb-3">
            <div class="w-full flex flex-col">
              <b-field :label="$t('represents_completion_status')">
                <b-switch v-model="form.is_completion" :value="form.is_completion" type="is-success"></b-switch>
              </b-field>
            </div>
          </div>

          <div class="w-full pb-3">
            <div class="w-full flex flex-col">
              <b-field :label="$t('status_visibility')">
                <b-input v-if="visibility === 'visible_default'"
                  :placeholder="$t('visible_for_all')"
                  :disabled="true"></b-input>

                <template v-else>
                  <div class="flex flex-col w-full">
                    <b-field v-if="visibility === 'visible_users'">
                      <b-switch v-model="collaboratorUsers">{{ $t('collaborator_users') }}</b-switch>
                    </b-field>
                    <MultiSelect
                      v-model="form.visible_for"
                      :options="visibilityOptions"
                      :loading="loadingVisibilityOptions"
                      :multiple="true"
                      :taggable="true"
                      label="label"
                      :hide-selected="true"
                      track-by="value"
                      :show-labels="false"
                      :placeholder="$t(selectPlaceholder)"
                      @search-change="asyncSearchVisibilityFind"
                    />
                  </div>
                </template>
              </b-field>
            </div>
          </div>

          <div v-if="showActions" class="w-full flex flex-row justify-between gap-x-2 pb-3">
            <button
              class="btn btn-blue"
              nativeType="submit"
            >
              {{ $t( form.id != null ? 'edit' : 'add' ) }}
            </button>
            <button type="button"
              class="btn btn-default"
              @click="() => { $emit('epc-status-form-close') }">
              {{ $t('cancel') }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  import Form from 'vform'
  import MultiSelect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import axios from 'axios'
  import { STATUS_VISIBILITY_ROLES, buildRolesTextMap } from '../../data/status-visibility-roles.js'

  export default {
    name: "StatusForm",

    components: {
      MultiSelect,
    },

    props: {
      status: { type: Object, default: null }, //
      colorpickerInline: { type: Boolean, default: false }, // Indica si el selector de color se mostrara en linea o haciendo click en un input
      showActions: { type: Boolean, default: true }, // Indica si se mostraran los botones de acciones
      showHeader: { type: Boolean, default: true }, // Indica si se mostrara el encabezado del formulario
      weightingCriteria: { type: String, default: null }, // Criterio de ponderación que se puede usar si es necesario
      visibility: { type: String, default: 'visible_default' }, // Visibilidad que se puede usar si es necesario
    },

    data() {
      return {
        isModalActive: false,
        isOpen: false,
        isLoading: true,
        assignmentId: 0,

        processingData: false,

        form: new Form({
          id: this.status?.id ?? null,
          layer_id: this.status?.layer_id ?? null,
          group_id: this.status?.group_id ?? null,
          code: this.status?.code ?? null,
          name: this.status?.name ?? null,
          weight: this.status?.weight ?? null,
          is_completion: this.status?.is_completion ?? false,
          color: this.status?.color ?? null,
          type: this.status?.type ?? 'status',
          visibility: this.visibility ?? 'visible_default',
          visible_for: this.status?.visible_for ?? [],
        }),

        formatColor: 'hex',

        collaboratorUsers: false,
        visibilityOptions: [],
        selectPlaceholder: 'select_users',
        loadingVisibilityOptions: false,

        // Catálogo de roles desde la fuente única (evita duplicar/desincronizar).
        roles: STATUS_VISIBILITY_ROLES.map(r => ({ value: r.value, label: this.$t(r.labelKey) })),
        rolesText: buildRolesTextMap(this.$t.bind(this)),
      }
    },

    mounted() {

    },

    computed: {
      ...mapGetters({
        project: "app/project",
      }),
    },

    watch: {
      visibility: {
        handler(newVal) {
          // Normalizar valores antiguos a nuevos formatos
          // by_roles -> visible_roles, by_users -> visible_users, public -> visible_default
          const normalizedValue = this._normalizeVisibility(newVal);

          // Actualizar form.visibility cuando cambia la prop
          this.form.visibility = normalizedValue;

          if (normalizedValue === 'visible_roles') {
            this.visibilityOptions = [...this.roles];
            this.selectPlaceholder = 'select_roles';
          } else if (normalizedValue === 'visible_users') {
            this.visibilityOptions = [];
            this.selectPlaceholder = 'select_users';
          } else {
            this.visibilityOptions = [];
            this.selectPlaceholder = 'select_users';
          }
        },
        immediate: true // Ejecutar al montar el componente
      },
      status: {
        handler(newVal) {
          if (newVal) {
            // Actualizar todos los campos del formulario
            this.form.id = newVal.id ?? null;
            this.form.layer_id = newVal.layer_id ?? null;
            this.form.group_id = newVal.group_id ?? null;
            this.form.code = newVal.code ?? null;
            this.form.name = newVal.name ?? null;
            this.form.weight = newVal.weight !== undefined && newVal.weight !== null ? newVal.weight : null;
            this.form.is_completion = newVal.is_completion ?? false;
            this.form.color = newVal.color ?? null;
            this.form.type = newVal.type ?? 'status';

            // Manejar permisos - usar valor normalizado
            const normalizedVisibility = this._normalizeVisibility(this.visibility);

            if (newVal.permissions && newVal.permissions.length > 0) {
              if (normalizedVisibility === 'visible_roles') {
                this.form.visible_for = newVal.permissions.map(p => ({
                  value: p.name,
                  label: this.rolesText[p.name],
                }));
                // Establecer las opciones de roles para el MultiSelect
                this.visibilityOptions = [...this.roles];
              }

              if (normalizedVisibility === 'visible_users') {
                this.form.visible_for = newVal.permissions.map(p => ({
                  value: p.user_id,
                  label: p.email,
                }));

                this.visibilityOptions = newVal.permissions.map(p => ({
                  label: p.email,
                  value: p.user_id,
                }));
              }
            } else {
              // Si no hay permisos (nuevo status o status sin permisos), limpiar visible_for
              this.form.visible_for = [];
            }
          }
        },
        immediate: true,
        deep: true,
      },
    },

    methods: {
      /**
       * Normaliza los valores de visibilidad antiguos a los nuevos formatos
       * by_roles -> visible_roles, by_users -> visible_users, public -> visible_default
       */
      _normalizeVisibility(value) {
        const mapping = {
          'public': 'visible_default',
          'by_roles': 'visible_roles',
          'by_users': 'visible_users',
          'visible_default': 'visible_default',
          'visible_roles': 'visible_roles',
          'visible_users': 'visible_users',
        };
        return mapping[value] || 'visible_default';
      },

      formatter (color) {
        return color.toString(this.formatColor)
      },

      async asyncSearchVisibilityFind(query) {
        this.loadingVisibilityOptions = true;
        if ( query.length < 1 ) {
          this.visibilityOptions = [];
          this.loadingVisibilityOptions = false;
          return;
        }

        const url = '/api/v2/project/users/search';

        const params = {
          q: query,
          only_internal: this.collaboratorUsers ? 0 : 1,
          only_external: this.collaboratorUsers ? 1 : 0,
        }

        const { data } = await axios.get(url, { params });

        if ( data.success ) {
          const users = data.users.map(user => ({
            // label: user.name + ' ' + user.surname,
            label: user.email,
            value: user.id,
          }));
          this.visibilityOptions = users;
        } else {
          this.visibilityOptions = [];
        }

        // this.visibilityOptions = await this.roles.filter(role => role.label.toLowerCase().includes(query.toLowerCase()));
        this.loadingVisibilityOptions = false;
      },

      getData() {
        // Usar el valor normalizado de form.visibility en lugar de this.visibility
        const normalizedVisibility = this.form.visibility;

        let permissions = [];
        if (normalizedVisibility === 'visible_roles') {
          permissions = this.form.visible_for.map(p => ({
            name: p.value,
          }));
        } else if (normalizedVisibility === 'visible_users') {
          permissions = this.form.visible_for.map(p => ({
            email: p.label,
            user_id: p.value
          }));
        }

        return {
          id: this.form.id,
          layer_id: this.form.layer_id,
          group_id: this.form.group_id,
          code: this.form.code,
          name: this.form.name,
          weight: this.form.weight,
          color:  this.form.color == null || this.formatter(this.form.color) === '#000000' ? null : this.formatter(this.form.color),
          is_completion: this.form.is_completion,
          type: this.form.type,
          permissions,
        };
      }
    }
  };
</script>

<style scoped>
</style>
